import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { setFirebaseAuth } from '@trader-dashboard/database';
const AuthenticationContext = createContext(undefined);
export const AuthProvider = ({ children, appFirebaseAuth }) => {
    const [loaded, setLoaded] = useState(false);
    const [authenticated, setAuthenticated] = useState(false);
    const [userId, setUserId] = useState();
    const [email, setEmail] = useState();
    const [isRootAdmin] = useState(false);
    // const { capture, identify } = useAnalytics(); // Temporarily removed
    // Set Firebase Auth instance for Supabase on mount
    useEffect(() => {
        setFirebaseAuth(appFirebaseAuth);
        console.log('🔐 Firebase Auth instance set for Supabase');
    }, [appFirebaseAuth]);
    const setUser = useCallback((user) => {
        if (!user) {
            setUserId(undefined);
            setAuthenticated(false);
            setEmail(undefined);
            // Track logout
            // capture('user_logout'); // Temporarily removed
        }
        else {
            setEmail(user.email);
            setUserId(user.uid || user.Id);
            setAuthenticated(true);
            // Identify user in analytics
            // identify(user.uid || user.Id, {
            //   email: user.email,
            //   user_id: user.uid || user.Id,
            //   login_method: user.providerData?.[0]?.providerId || 'unknown'
            // });
            // Track successful login
            // capture('user_login', {
            //   login_method: user.providerData?.[0]?.providerId || 'unknown',
            //   email: user.email,
            //   user_id: user.uid || user.Id
            // });
        }
    }, []); // [capture, identify]); // Temporarily removed analytics dependencies
    useEffect(() => {
        if (appFirebaseAuth.currentUser) {
            console.log('User is already logged in');
            setUser(appFirebaseAuth.currentUser);
            setAuthenticated(true);
        }
        const unsubscribe = onAuthStateChanged(appFirebaseAuth, (user) => {
            setUser(user);
            setLoaded(true);
        });
        setLoaded(true);
        return unsubscribe;
    }, [setUser]);
    const loggedIn = async () => {
        setAuthenticated(true);
    };
    const loggedOut = async () => {
        setAuthenticated(false);
    };
    const checkAuthStatus = async () => {
        await appFirebaseAuth.authStateReady();
        if (appFirebaseAuth.currentUser) {
            console.log('User is already logged in');
            setUser(appFirebaseAuth.currentUser);
            setAuthenticated(true);
        }
        else {
            setUser(undefined);
            setAuthenticated(false);
        }
    };
    return (_jsx(AuthenticationContext.Provider, { value: { loaded, authenticated, email, userId, isRootAdmin,
            setUser, loggedIn, loggedOut, checkAuthStatus }, children: children }));
};
export const useAuth = () => {
    const context = useContext(AuthenticationContext);
    if (!context) {
        throw new Error('useAuth must be used within a AuthProvider');
    }
    return context;
};
